import styled, { from } from 'theme';

export const AddAccountFormWrapper = styled.div`
  ${from('xlg')} {
    .account-add {
      max-width: 34rem;
      padding: 3.1875rem 5rem;
    }

    .account-add__body {
      padding: 2rem 2rem 3rem;
    }
  }
`;

export const AddAccountFormFooter = styled.div`
  display: flex;
  justify-content: flex-end;
`;
